import type { DirectiveBinding } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('ui-test-name', {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
      el.setAttribute('data-selenide', binding.value)
    },
  })
})
